var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReadAllAlt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 26,
    viewBox: "0 0 25 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.75 4.25L4.25 6.75L9.25 1.75",
    stroke: "#E2053F",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.25 2.375H21.75C22.2473 2.375 22.7242 2.57254 23.0758 2.92417C23.4275 3.27581 23.625 3.75272 23.625 4.25C23.625 4.74728 23.4275 5.22419 23.0758 5.57583C22.7242 5.92746 22.2473 6.125 21.75 6.125H14.25C13.7527 6.125 13.2758 5.92746 12.9242 5.57583C12.5725 5.22419 12.375 4.74728 12.375 4.25C12.375 3.75272 12.5725 3.27581 12.9242 2.92417C13.2758 2.57254 13.7527 2.375 14.25 2.375Z",
    stroke: "#E2053F",
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.75 13L4.25 15.5L9.25 10.5",
    stroke: "#E2053F",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21.75 11.125H14.25C13.2145 11.125 12.375 11.9645 12.375 13C12.375 14.0355 13.2145 14.875 14.25 14.875H21.75C22.7855 14.875 23.625 14.0355 23.625 13C23.625 11.9645 22.7855 11.125 21.75 11.125Z",
    stroke: "#E2053F",
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M1.75 21.75L4.25 24.25L9.25 19.25",
    stroke: "#E2053F",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M21.75 19.875H14.25C13.2145 19.875 12.375 20.7145 12.375 21.75C12.375 22.7855 13.2145 23.625 14.25 23.625H21.75C22.7855 23.625 23.625 22.7855 23.625 21.75C23.625 20.7145 22.7855 19.875 21.75 19.875Z",
    stroke: "#E2053F",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReadAllAlt);
export default __webpack_public_path__ + "static/media/read-all-alt.2008c7cda71f4028fb6240879c828894.svg";
export { ForwardRef as ReactComponent };